import { SelectOptionType } from '@octano/global-ui';
import { useState } from 'react';
import { DefaultValues } from 'react-hook-form';
import { Card } from 'reactstrap';
import { FieldValues } from 'react-hook-form';
import DisplayError from '../info/DisplayError';
import RenderForm, { ButtonData } from './parts/RenderSections';

export interface DynamicFormBaseProps {
  defaultValues?: DefaultValues<any>;
  /**
   * optionalValues corresponde a valores por defecto
   * que dependen de una condicion para mostrarse.
   */
  optionalValues?: DefaultValues<any>;
  /**
   * Cuando dynamic form recibe un objeto con las opciones,
   * estas se mostrarán el el campo que coincida con el nombre
   * de la propiedad.
   */
  options?: Record<string, SelectOptionType[]>;
  /**
   * sectionComponents en el json se puede definir un componente a una seccion
   * cuando esto ocurre es necesario pasar un objeto con componentes a renderizar.
   */
  sectionComponents?: Record<string, JSX.Element>;
  /**
   * Buttons para el formulario
   */
  formButtons?: ButtonData[];
  structure?: any;
  isModalRender?: boolean;
  onSubmit: (data: FieldValues) => Promise<void>;
  readOnly?: boolean;
}

function DynamicFormBase(props: DynamicFormBaseProps) {
  const {
    structure,
    defaultValues,
    optionalValues,
    sectionComponents,
    options,
    onSubmit,
    formButtons,
    isModalRender,
    readOnly,
  } = props;

  const [error, setError] = useState<string[]>();

  if (error) {
    return <DisplayError insideCard textBody={'Error de dependencias'} />;
  }

  if (!structure) {
    return <DisplayError insideCard textBody={'Estructura no cargada'} />;
  }

  return (
    <Card>
      <RenderForm
        sectionComponents={sectionComponents}
        structureBtns={formButtons}
        structure={structure}
        onErrors={setError}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        optionalValues={optionalValues}
        options={options}
        isModalRender={isModalRender}
        readOnly={readOnly}
      />
    </Card>
  );
}
export default DynamicFormBase;
